import React from 'react'
import ContactForm from '../../Components/ContactForm'
function Index() {
  return (
    <div className='w-full flex center '>
      <div className="grid grid-cols-12 w-[80%] lg:gap-20 mt-20 lg:mt-40 mb-20 ">
        <div className="col-span-12 w-full mt-5 lg:mt-0  lg:col-span-8 bg-black p-10 lg:p-20">
          <h1 className='text-white  tex-regular text-2xl lg:text-4xl'>NA KONTAKTONI </h1>
          x
          <ContactForm />
        </div>
        <div className="col-span-12 lg:col-span-4 mt-10 lg:mt-0">
          <div className="w-full bg-black  p-10">
            {/* instagram */}
            <div className=" w-full  flex ">
              <div className="grid grid-cols-12 gap-5">
                <div className="col-span-2">
                  <img className='w-[20px] lg:w-[25px]' src="/images/socials/instagram (1).png" alt="" />
                </div>
                <div className="col-span-10">
                  <h2 className='montserrat font-semibold text-white text-xs lg:text-base w-fit'>
                    @hitimperial.ks
                  </h2>
                </div>
              </div>
            </div>

            {/* faceboook */}
            <div className=" w-full  flex mt-10 ">
              <div className="grid grid-cols-12 gap-5">
                <div className="col-span-2">
                  <img className='w-[20px] lg:w-[25px]' src="/images/socials/social-media.png" alt="" />
                </div>
                <div className="col-span-10">
                  <h2 className='montserrat font-semibold text-white text-xs lg:text-base w-fit'>
                    @hitimperial
                  </h2>
                </div>
              </div>
            </div>

            {/* phone */}
            <div className=" w-full  flex mt-10 ">
              <div className="grid grid-cols-12 gap-5">
                <div className="col-span-2">
                  <img className='w-[20px] lg:w-[25px]' src="/images/socials/telephone.png" alt="" />
                </div>
                <div className="col-span-10">
                  <h2 className='montserrat font-semibold text-white text-xs lg:text-base w-fit'>
                      +383 (0) 44 100 710
                  </h2>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  )
}

export default Index